import NativeLogBox from 'react-native/Libraries/NativeModules/specs/NativeLogBox';

export default NativeLogBox;
